// extracted by mini-css-extract-plugin
export default {"root":"ChecklistItem_root__kEeRh","checkbox":"ChecklistItem_checkbox__I3ZBf"};